import { useState } from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';
import CookiesBar from './components/CookiesBar';
import MobileBanner from './components/MobileBanner';
import PrivateRoutes from './components/PrivateRoute';
import AdminPrivateRoutes from './components/PrivateRoute/PrivateAdminRoute';
import ActivateAccount from './pages/Activate';
import AdminPage from './pages/Admin/Admin';
import AdminLoginPage from './pages/Admin/AdminLogin';
import ForgotPasswordPage from './pages/ForgotPassword';
import HomePage from './pages/Homepage';
import LoginPage from './pages/Login';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import RegisterPage from './pages/Register';
import ResetPasswordPage from './pages/ResetPassword';
import TermsOfUsePage from './pages/TermsOfUse';
import { GlobalStyle } from './styles/Global';
import { theme } from './theme/Theme';

const App = () => {
  const [showMobileBanner, setShowMobileBanner] = useState(true);
  return (
    <div>
      <ThemeProvider theme={theme}>
        <MobileBanner
          onConfirm={() => setShowMobileBanner(false)}
          active={showMobileBanner}
        />
        <GlobalStyle />
        <CookiesBar />
        <ToastContainer
          position={toast.POSITION.TOP_RIGHT}
          theme="colored"
          newestOnTop
          pauseOnHover={false}
          hideProgressBar
          closeButton={false}
        />
        <BrowserRouter>
          <CookiesProvider>
            <Routes>
              <Route element={<PrivateRoutes />}>
                <Route path="/:apiKey?" element={<HomePage />} />
              </Route>
              <Route element={<AdminPrivateRoutes />}>
                <Route path="/admin/:tab?" element={<AdminPage />} />
              </Route>
              <Route path="/login/admin" element={<AdminLoginPage />} />
              <Route
                path="/activate/:activationToken"
                element={<ActivateAccount />}
              />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/reset-password/:resetToken"
                element={<ResetPasswordPage />}
              />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
            </Routes>
          </CookiesProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
};

export default App;
